import { useTranslation } from 'react-i18next';
import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ApiErrorException } from '@/api/client';

/** The server code of a failed request, when it gave one (DES-16). */
export function errorCode(err: unknown): string | undefined {
  return err instanceof ApiErrorException ? err.code : undefined;
}

/**
 * A figure that could not be loaded (DES-12, DES-16): the translated message
 * first, the server code in small monospace, and « Réessayer ». Never a 0.
 */
export function LoadError({ error, onRetry, className = '' }: { error: unknown; onRetry: () => void; className?: string }) {
  const { t } = useTranslation(['dialer', 'common']);
  const code = errorCode(error);
  return (
    <div role="alert" className={`flex flex-wrap items-center gap-3 text-sm ${className}`}>
      <span className="text-foreground">{t('dialer:analytics.loadError')}</span>
      {code && <span className="font-vf-mono text-[11px] text-muted-foreground">{code}</span>}
      <Button type="button" variant="outline" size="sm" onClick={onRetry}>
        <RefreshCw className="w-3.5 h-3.5 mr-1.5" aria-hidden />{t('common:actions.retry')}
      </Button>
    </div>
  );
}
